import { render } from "./ViewIncidencia.vue?vue&type=template&id=9a90e234"
import script from "./ViewIncidencia.vue?vue&type=script&lang=js"
export * from "./ViewIncidencia.vue?vue&type=script&lang=js"

import "./ViewIncidencia.vue?vue&type=style&index=0&id=9a90e234&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__